import { Box, Tooltip } from '@mui/material'
import { IconFlag } from '@tabler/icons-react'
import type { AssistantGoal } from 'types/graphql'

import { logger } from 'src/lib/logger'

import BaseChip from '../Chips/BaseChip'

const AssistantGoalChip = ({
  assistantGoal,
}: {
  assistantGoal: AssistantGoal
}) => {
  logger.dev('AssistantGoalChip', {
    assistantGoal,
  })
  return (
    <Tooltip title={assistantGoal.description || 'No description available'}>
      <Box>
        <BaseChip
          label={assistantGoal.name}
          icon={<IconFlag size={16} />}
        />
      </Box>
    </Tooltip>
  )
}

export default AssistantGoalChip
